import React, { Component } from 'react';

class ProductFields extends Component {

    render() {
        return (
            <React.Fragment>
                {this.props.fields.map(field =>
                    <div className={`form-group ${field.class ? field.class : 'col-sm-12'}`} key={field.label}>
                        <label>{field.label} <small className="text-danger">{field.required ? "*" : ""}</small></label>
                        {field.type === "textarea" ? (
                            <textarea
                                className={`form-control ${field.classError}`}
                                name={field.name}
                                required={field.required}
                                rows="3"
                                value={field.value}
                                onChange={(event) => this.props.handleChange(event, field.name)}
                                onClick={(event) => this.props.showKeyboard(event, this.props.handleChange)}
                            ></textarea>
                        ) : (
                            <input
                                type={field.type}
                                value={field.value}
                                className={`form-control ${field.classError}`}
                                name={field.name}
                                required={field.required}
                                onChange={(event) => this.props.handleChange(event, field.name)}
                                onClick={(event) => this.props.showKeyboard(event, this.props.handleChange)}
                            />
                        )}
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default (ProductFields);